"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ai_1 = require("react-icons/ai");
const react_icons_1 = require("react-icons");
const Loader = (props) => (react_1.default.createElement(react_icons_1.IconContext.Provider, { value: { className: `ff-loader ${props.className}` } },
    react_1.default.createElement(ai_1.AiOutlineLoading3Quarters, null)));
exports.default = Loader;
//# sourceMappingURL=Loader.js.map